import React, { useState, useEffect, useContext, memo } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ProductLayer from '../ProductLayer';
import usePrevious from '../../hooks/usePrevious';
import AppTypeContext from '../../contexts/AppTypeContext';
import API from '../../services/API';
import { togglePostModal } from '../../redux/slices';
import i18next from '../../translations/i18n';

const UnderlyingCard = memo(
  ({ underlying, setOpenModal, postTitle, postId }) => {
    const dispatch = useDispatch();
    const underlyingName = underlying.name ? underlying.name.toLowerCase() : '';
    const postToToggle = `${postId}-${underlyingName}`;
    const isOpen = useSelector(
      (state) => state.app.modals[postToToggle] || false,
    );
    const prevCount = usePrevious(underlying.chg);

    const [className, setClassName] = useState('');
    const [openLayer, setOpenLayer] = useState(isOpen);
    const appName = useContext(AppTypeContext);
    const toggleUnderlyingModal = () => {
      // toggleUnderlyingModal(!isOpen)
      dispatch(togglePostModal(postToToggle));
      setOpenLayer(isOpen);
    };

    const [bg, setBg] = useState(
      `rgba(${[
        underlying.color.r,
        underlying.color.g,
        underlying.color.b,
        underlying.color.a,
      ].join(',')})`,
    );

    useEffect(() => {
      if (prevCount === undefined) {
        return;
      }
      if (prevCount !== underlying.chg) {
        setClassName('blink');
        setBg(
          `rgba(${[
            underlying.color.r,
            underlying.color.g,
            underlying.color.b,
            underlying.color.a,
          ].join(',')})`,
        );
      }
      setTimeout(() => {
        setClassName('');
      }, 1000);
      setOpenModal(document.querySelectorAll('.underlying-modal').length > 0);
    }, [prevCount, underlying, isOpen]);

    return (
      <React.Fragment key={underlying.name}>
        <Card
          style={{ maxWidth: '20rem', background: bg }}
          onMouseEnter={() => {
            setBg(
              `rgba(${[
                underlying.color.r,
                underlying.color.g,
                underlying.color.b,
                0.7,
              ].join(',')})`,
            );
          }}
          onMouseLeave={() => {
            setBg(
              `rgba(${[
                underlying.color.r,
                underlying.color.g,
                underlying.color.b,
                underlying.color.a,
              ].join(',')})`,
            );
          }}
          size="lg"
          className={`underlying rounded-1 ${className}`}
        >
          <Card.Body className="p-2 px-3">
            <Card.Text className="underlying-txt mb-2">
              <Trans>{underlying.name}</Trans>
            </Card.Text>
            <div className="d-flex justify-content-between gap-3">
              <Card.Text className="align-self-center m-0 fw-bold">
                {underlying.chg}%
              </Card.Text>
              <Card.Text className="">
                {i18next.t('viewProducts')}
                <span className="right-arrow" />
              </Card.Text>
            </div>
            <Card.Link
              type={`${appName}-${postTitle}`}
              name={underlying.name}
              className="stretched-link underlying-txt"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                API.sendToGA(
                  postTitle
                    ? `${appName}-open-${underlying.name}-${postTitle}`
                    : `${appName}-open-${underlying.name}`,
                );
                toggleUnderlyingModal(!openLayer);
              }}
            />
          </Card.Body>
        </Card>
        <ProductLayer
          postTitle={postTitle}
          product={underlying}
          show={isOpen}
          onHide={() => toggleUnderlyingModal(false)}
          onEscapeKeyDown={(e) => {
            e.preventDefault();
            toggleUnderlyingModal(false);
          }}
          style={{ opacity: openLayer ? 1 : 0 }}
        />
      </React.Fragment>
    );
  },
);
UnderlyingCard.propTypes = {
  underlying: PropTypes.shape({
    name: PropTypes.string.isRequired,
    chg: PropTypes.string.isRequired,
    color: PropTypes.shape({
      r: PropTypes.number.isRequired,
      g: PropTypes.number.isRequired,
      b: PropTypes.number.isRequired,
      a: PropTypes.number.isRequired,
    }),
  }).isRequired,
  setOpenModal: PropTypes.func.isRequired,
  postTitle: PropTypes.string.isRequired,
  postId: PropTypes.string.isRequired,
};
UnderlyingCard.displayName = 'UnderlyingCard';
export default UnderlyingCard;
